import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { setIsScrolled } from './actions'
import { addressesRuianIdChange } from './components/FirmsOnAddress/actions'
import { googleMapToggleCollapsed } from '../../../../../../../../../components/GoogleMap/actions'

function mapStateToProps(state, hocProps) {
    const module = _.get(hocProps, 'module', null)
    const block = _.get(hocProps, 'block', null)
    const entId = _.get(hocProps, 'id', null)

    return {
        transformedData: state.getIn(['ui', 'modules', module, 'workspace', entId, 'blocks', block, 'transformedData']),
        firmsOnAddressSummary: state.getIn([
            'ui',
            'workspace',
            module,
            entId,
            'blocks',
            block,
            'customData',
            'firmsOnAddress',
            'summary',
        ]),
        mapCollapsed: state.getIn(['ui', 'googleMap', entId, 'collapsed']),
        isScrolled: state.getIn(['ui', 'workspace', 'report', 'isScrolled']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addressesRuianIdChange,
            googleMapToggleCollapsed,
            setIsScrolled,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
